import axios from 'axios'
import { refresh } from './auth.service.js'
import config from '../config/dev.json'

let path = '/api/v1'
let url = config.host + path +'/secure' 
let urlSecure = config.host + path + '/secure'
let urlUp = config.host + path + '/file'

import production from '../config/production.json'
import Vue from 'vue';
if( process.env.NODE_ENV === 'production'){
  url = production.host + path + '/secure'
}

export async function getUserById(id) {
  return new Promise((resolve, reject) => {
    axios.get(urlSecure + '/get/'+id).then((response) => {
      let user = response.data.data
      resolve(user)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getUserById(id)) 
        }).catch(err => reject(err))
      } else {
        reject(err)
      }
    })
  })
}

// upload nrmlm tkoun fi upload file // serviceuploadfile intent
export async function uploadFileExcel(formData, id){
  return new Promise((resolve, reject) => {
    console.log('tets data', formData)
    axios.post(urlUp + '/upload/'+id , formData,
    {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      console.log('tetst res', response.data.data)
      location.reload()
      resolve(response.data.data)
    })
  })
}

export async function uploadImageProfile(formData, id){
  return new Promise((resolve, reject) => {
    axios.post(urlUp + "/profile/image/" +id, formData, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      resolve(response.data.data)
    }).catch(err => reject(err))
  })
}

export async function updateUserInfo(user) {
  return new Promise((resolve, reject) => {
    console.log('tetst update ', user)
    axios.put(urlSecure+ '/profile/update/'+user._id, user).then((response) => {
      let user = response.data.data
      resolve(user)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(updateUserInfo(user))
        }).catch(err => {
          reject(err)
        })
      } else {
        reject(err)
      }
    })
  })
}

export async function deleteUser(token) {
  return new Promise((resolve, reject) => {
    axios.delete(urlSecure + '/delete', token).then((response) => {
      resolve(response)
    }).catch(err => {
      if( err.repsonse.status === 401) {
        refresh().then(() => {
          resolve(deleteUser())
        }).catch(err => {
          reject(err)
        })
      } else {
        reject(err)
      }
    })
  })
}

export async function changePassword(pwd) {
  return new Promise((resolve, reject) =>  {
    console.log('test pwd ', pwd)
    axios.post(urlSecure + '/profile/changepassword', pwd).then((response) => {
      console.log('test dtaa', response.data.data)
      let msg = response.data.data
      resolve(msg)
    }).catch(err => {
      console.log('test err mere', err)
      if(err.response.status === 401)
      {refresh().then(() => {
        resolve(changePassword(pwd))
      }).catch(err => reject(err))}
      else {
        console.log('test err', err)
        let propsData = {
          direction: "right",
          duration: 1500
        }
        Vue.prototype.$notif.show(
              (propsData = {
                title: "Error !",
                message: "Check your password !",
                type: "danger"
              })
            );
        reject(err)
      }
    })
  })
}

export async function getCountries() {
  return new Promise((resolve, reject) => {
    axios.get('https://restcountries.eu/rest/v1/all').then((response) => {
      let countries = new Array
      response.data.forEach(element => {
        countries.push(element.name)
      });
      resolve(countries)
    })
  }).catch(err => {
    reject(err)
  })
}


// WEBPACK FOOTER //
// ./src/api/users.service.js